export default {
  items: [
    {
      title: true,
      name: 'Dashboard',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      title: true,
      name: 'Users',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'User list',
      url: '/users',
      icon: 'icon-people'
    },
    {
      name: 'Admin list',
      url: '/admins',
      icon: 'icon-user'
    },    
    {
      title: true,
      name: 'Groups',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Group list',
      url: '/groups',
      icon: 'icon-docs'
    },    
    {
      name: 'Import',
      url: '/groups/addGroupWithUsers',
      icon: 'icon-user-follow'
    },    
    {
      title: true,
      name: 'Devices',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Device list',
      url: '/devices',
      icon: 'icon-disc'
    },
    {
      title: true,
      name: 'Logs',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Log list',
      url: '/logs',
      icon: 'icon-layers'
    },    
  ]
}
